import { render } from "./HomeView.vue?vue&type=template&id=72b563a9&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=72b563a9&scoped=true&lang=css"

import exportComponent from "/Users/georgeconstantine/Documents/import/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b563a9"]])

export default __exports__